import { Component, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';
import { TableMeta } from '../../../../models/table-meta.interface';
import { JobOrderVendorService, JobOrderServiceAttribute } from '../../../../models/job-orders.interface';
import { RightPanelComponent } from '../../../right-panel/right-panel.component';
import { InventoryType } from '../../../../constants/app-constants';
import { VendorServiceFormComponent } from '../vendor-service-form/vendor-service-form.component';
import config from './manage-service-config.json';
import { StaticTableComponent } from '../../../static-table/static-table.component';
import { FormGroup } from '@angular/forms';
import { DynamicForm } from '../../../../models/dynamic-form';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { DynamicFormService } from '../../../../services/dynamic-form.service';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-vendor-accordion-content',
  standalone: true,
  imports: [StaticTableComponent, SharedModule, DynamicFormComponent],
  templateUrl: './vendor-accordion-content.component.html',
  styleUrl: './vendor-accordion-content.component.scss'
})
export class VendorAccordionContentComponent {

  @Input() serviceList!: JobOrderVendorService[];
  @Input() inventoryType!: InventoryType;
  @Input() itemDetails!: any;
  @Input() formGroup!: FormGroup;
  @Input() dynamicForm!: DynamicForm;
  @Input() readonly: boolean = false;

  @Output() serviceListChanged = new EventEmitter<JobOrderVendorService[]>();

  InventoryType = InventoryType;
  serviceTableMeta!: TableMeta;

  constructor(private viewContainerRef: ViewContainerRef, 
    private dynamicFormService: DynamicFormService) {
    this.serviceTableMeta = config.serviceTableMeta;
  }

  ngOnInit() {
    this.serviceList?.forEach(js => this.updateAttributeListView(js)); 
    console.log("dynamic form: ", this.dynamicForm);
    if (this.dynamicForm && this.formGroup) {
      this.dynamicFormService.addControlsToForm(this.formGroup, this.dynamicForm, false);
      this.formGroup.patchValue({
        ...this.itemDetails
      });
    }
  }

  editService(event: {index: number, record: any}) {
    const joborderService = this.serviceList[event.index];
    const rightPanelComponentRef = this.viewContainerRef.createComponent(RightPanelComponent);
    rightPanelComponentRef.instance.title = "Edit Service";
    rightPanelComponentRef.instance.showActionBtns = true;
    
    const manageAttributeRef = rightPanelComponentRef.instance.loadComponent(VendorServiceFormComponent);
    manageAttributeRef.setInput("jobOrderVendorService", joborderService);
    manageAttributeRef.setInput("inventoryType", this.inventoryType);
    
    rightPanelComponentRef.instance.primaryActionBtnEmitter.subscribe((data) => {
      manageAttributeRef.instance.saveForm();
    })

    manageAttributeRef.instance.onSave.subscribe((event: {jobOrderVendorService: JobOrderVendorService, appliedInventoryIds: string[]}) => {
      this.updateAttributeListView(joborderService);
      rightPanelComponentRef.destroy();
    });

    rightPanelComponentRef.instance.close.subscribe(() => {rightPanelComponentRef.destroy()});
  }
  
  private updateAttributeListView(joborderService: JobOrderVendorService) {
    if (joborderService.attributes?.length) {
      for (let j = 0; j < joborderService.attributes?.length; j++) {
        const attribute = joborderService.attributes[j];
        attribute.displayValue = `${attribute.name} : ${attribute.values[0].value}`;
      }
    }
  }

  onServiceListChange(updatedList: JobOrderVendorService[]) {
    this.serviceList = updatedList;
    this.serviceListChanged.emit(updatedList);
  }

}
